module.exports = __webpack_public_path__ + "static/media/CTLI_14-391w.2368d8c5.png";